import React from "react";
import { CheckCircleIcon } from "@heroicons/react/24/solid";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ActivationSuccess: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");

  // If we're here, Stripe checkout was successful.
  // The webhook handles DB update in the background — no need to poll.
  // Just mark activated in localStorage for any local checks.
  if (sessionId) {
    localStorage.setItem("dealer_activated", "true");
  }

  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-4">
      <div className="max-w-lg w-full bg-white rounded-xl shadow-lg p-8 text-center">
        <div className="flex justify-center mb-4">
          <CheckCircleIcon className="h-14 w-14 text-green-500" />
        </div>
        <h1 className="text-2xl font-bold text-secondary mb-2">
          {t("activation.success")}
        </h1>
        <p className="text-gray-600 mb-6">
          {t("activation.successDescription")}
        </p>
        <div className="flex gap-3 justify-center">
          <button
            onClick={() => navigate("/")}
            className="inline-flex items-center px-4 py-2 rounded-md bg-primary-600 text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
          >
            {t("payment.goToDashboard")}
          </button>
          <button
            onClick={() => navigate("/deposit")}
            className="inline-flex items-center px-4 py-2 rounded-md bg-gray-100 text-secondary hover:bg-gray-200"
          >
            {t("activation.makeDeposit")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ActivationSuccess;
